import { useBoardSwitcherLayout } from '@trello/board-switcher';

import * as styles from './BoardSwitcherTilesLoadingSkeleton.module.less';

export const BoardSwitcherTilesLoadingSkeleton = () => {
  const layout = useBoardSwitcherLayout();

  if (layout === 'list') {
    return (
      <div className={styles.listTilesWrapper}>
        <div className={styles.listItem}></div>
        <div className={styles.listItem}></div>
        <div className={styles.listItem}></div>
        <div className={styles.listItem}></div>
      </div>
    );
  }

  return (
    <div className={styles.gridTilesWrapper}>
      <div className={styles.gridItem}></div>
      <div className={styles.gridItem}></div>
      <div className={styles.gridItem}></div>
      <div className={styles.gridItem}></div>
    </div>
  );
};
